import React from 'react';
import cx from 'classnames';
import styles from './Button.module.scss';

const Button = ({ children, primary, component: ButtonComponent = 'button', ...rest }) => (
  <ButtonComponent
    type={typeof ButtonComponent === 'string' && ButtonComponent === 'button' ? 'button' : null}
    className={cx(styles.root, { [styles.root_primary]: primary })}
    {...rest}
  >
    {children}
  </ButtonComponent>
);

export default Button;
